import 'regenerator-runtime/runtime.js'
import Vue from 'vue'
import env from "^/utils/constants"
/*
Immediately start sentry logging as early as possible.
 */
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
if(env.SENTRY_DSN){
  Raven.config(env.SENTRY_DSN)
            .addPlugin(RavenVue, Vue)
            .install()

}
window.Raven = Raven

import Vuex from 'vuex'
import VueRouter from 'vue-router'
import PortalVue from 'portal-vue'
import {debugLog} from '^/utils'
import IxPlugin from '^/IxPlugin'
import store from '^/store'
import '^/base'
import {APIDEBUGMODE, tokenInspected} from '^/IxPlugin/api'
import VueScrollTo from 'vue-scrollto'
import get_script from '^/utils/getScript'
import mainOverrides from "vue-src/utils/mainOverrides"


const NODE_ENV = env.NODE_ENV
if (NODE_ENV !== 'production') {
  APIDEBUGMODE()
  if (window.location.search.indexOf('snippet_debug') >= 0) {
    document.body.classList.add('snippet_debug')
  }
}
Vue.use(IxPlugin)
Vue.use(Vuex)
Vue.use(PortalVue)
Vue.use(VueRouter)
Vue.use(VueScrollTo)

Vue.config.performance = NODE_ENV !== 'production'

store.dispatch('init')

// Static Component Imports
import HeaderNavMain from 'vue-src/top-level/header-nav-main'
import MobileNavMain from 'vue-src/top-level/mobile-nav-main'
import CartDropdown from 'vue-src/top-level/cart-dropdown'
import AccountNav from 'vue-src/top-level/account-nav'
import PortalVueModal from 'vue-src/top-level/portal-vue-modal'
import resellerModal from 'vue-src/top-level/reseller-modal'
import PortalRootContainer from 'vue-src/top-level/portal-root-container'
import MessageHandler from 'vue-src/top-level/message-handler'
import Breadcrumbs from 'vue-src/top-level/breadcrumbs'


// Dynamic Component Imports
const FeaturedProducts = () => import(
    /* webpackChunkName: "featured-products" */
    'vue-src/top-level/featured-products'
    )
const NewProducts = () => import(
    /* webpackChunkName: "new-products" */
    'vue-src/top-level/new-products'
    )
const FeaturedBrands = () => import(
    /* webpackChunkName: "featured-brands" */
    'vue-src/top-level/featured-brands'
    )
const FeaturedCategories = () => import(
    /* webpackChunkName: "featured-categories" */
    'vue-src/top-level/featured-categories'
    )
const ProductDetail = () => import(
    /* webpackChunkName: "product-detail-primary" */
    'vue-src/top-level/product-detail'
    )
const MxCategory = () => import(
    /* webpackChunkName: "mx-category" */
    'vue-src/top-level/mx-category'
    )
const ViewCart = () => import(
    /* webpackChunkName: "view-cart" */
    'vue-src/top-level/view-cart'
    )
// const LoginButton = () => import(
//     /* webpackChunkName: "login-button" */
//     'vue-src/top-level/login-button'
//     )
// const RegisterButton = () => import(
//     /* webpackChunkName: "register-button" */
//     'vue-src/top-level/register-button'
//     )
const Logout = () => import(
    /* webpackChunkName: "logout" */
    'vue-src/top-level/logout'
    )
const Checkout = () => import(
    /* webpackChunkName: "checkout" */
    'vue-src/top-level/checkout'
    )
const PortalLeftSidebar = () => import(
    /* webpackChunkName:"portal-left-sidebar"*/
    'vue-src/top-level/portal-left-sidebar'
    )
const InfoBox = () => import(
    /* webpackChunkName: "info-box" */
    'vue-src/components/global/info-box'
    )
const MyAccount = () => import(
    /* webpackChunkName: "my-account" */
    'vue-src/top-level/my-account'
    )
const OrderStatus = () => import(
    /* webpackChunkName: "order-status" */
    'vue-src/top-level/order-status'
    )
const Error404 = () => import(
    /* webpackChunkName:"error-404" */
    'vue-src/top-level/error-404'
    )
const SearchResults = () => import(
    /* webpackChunkName:"search-results" */
    'vue-src/top-level/search-results'
    )
const ItemsSearchResults = () => import(
    /* webpackChunkName:"items-search-results" */
    'vue-src/top-level/items-search-results'
    )
const CategorySearchResults = () => import(
    /* webpackChunkName:"category-search-results" */
    'vue-src/top-level/categories-search-results'
    )
const SearchSidebar = () => import(
    /* webpackChunkName:"search-results.sidebar" */
    'vue-src/top-level/search-results-sidebar'
    )

const RevolutionSlider = () => import(
    /* webpackChunkName:"revolution-slider" */
    'vue-src/theme-parts/revolution-slider'
    )

const VideoCategoryList = () => import(
    /* webpackChunkName:"video-category-list" */
    'vue-src/top-level/video-category-list'
    )




function init_components() {

  let inits = []

  mainOverrides.extraComponents({Vue, store, inits},0)


  if (document.querySelectorAll('#product-detail').length === 1) {
    inits.push('product-detail')
    new Vue({
      el: '#product-detail',
      store: store,
      render(e) {
        return e(ProductDetail)
      },
    })
  }

  if (document.querySelectorAll('#mx-category-app').length === 1) {
    inits.push('mx-category-app')
    new Vue({
      el: '#mx-category-app',
      store: store,
      render(e) {
        return e(MxCategory)
      }
    })
  }

  if (document.querySelectorAll('#vue-search-results').length === 1) {
    inits.push('vue-search-results')
    new Vue({
      el: '#vue-search-results',
      store: store,
      render(e) {
        return e(SearchResults)
      }
    })
  }
  if (document.querySelectorAll('#vue-product-search-results').length === 1) {
    inits.push('vue-product-search-results')
    new Vue({
      el: '#vue-product-search-results',
      store: store,
      render(e) {
        return e(ItemsSearchResults)
      }
    })
  }

  if (document.querySelectorAll('#vue-categories-search-results').length === 1) {
    inits.push('vue-categories-search-results')
    new Vue({
      el: '#vue-categories-search-results',
      store: store,
      render(e) {
        return e(CategorySearchResults)
      }
    })
  }
  if (document.querySelectorAll('#vue-search-sidebar').length === 1) {
    inits.push('vue-search-sidebar')
    new Vue({
      el: '#vue-search-sidebar',
      store: store,
      render(e) {
        return e(SearchSidebar)
      }
    })
  }

  if (document.querySelectorAll('#vue-left-sidebar').length === 1) {
    inits.push('vue-left-sidebar')
    new Vue({
      el: '#vue-left-sidebar',
      store: store,
      render(e) {
        return e(PortalLeftSidebar)
      }
    })
  }

  if (document.querySelectorAll('#vue-message-handler').length === 1) {
    inits.push('vue-message-handler')
    new Vue({
      el: '#vue-message-handler',
      store: store,
      render(e) {
        return e(MessageHandler)
      }
    })
  }

  if (document.querySelectorAll('#cart-area').length === 1) {
    inits.push('cart-area')
    new Vue({
      el: '#cart-area',
      store: store,
      components: {'cart-dropdown': CartDropdown}
    })
  }

  if (document.querySelectorAll('#vue-account-nav').length === 1) {
    inits.push('vue-account-nav')
    new Vue({
      el: '#vue-account-nav',
      store: store,
      render(e) {
        return e(AccountNav)
      }
    })
  }

  if (document.querySelectorAll('#header-nav-main').length === 1) {
    inits.push('header-nav-main')
    new Vue({
      el: '#header-nav-main',
      store: store,
      components: {'header-nav-main': HeaderNavMain}
    })
  }
  if (document.querySelectorAll('#vue-mobile-nav').length === 1) {
    inits.push('mobile-nav-main')
    new Vue({
      el: '#vue-mobile-nav',
      store: store,
      components:{MobileNavMain}
    })
  }


  if (document.querySelectorAll('#view-cart').length === 1) {
    inits.push('view-cart')
    new Vue({
      el: '#view-cart',
      store: store,
      components: {'view-cart': ViewCart}
    })
  }

  if (document.querySelectorAll('#vue-new-products').length === 1) {
    inits.push('vue-new-products')
    new Vue({
      el: '#vue-new-products',
      store: store,
      render(e) {
        return e(NewProducts)
      }
    })
  }

  if (document.querySelectorAll('#vue-featured-products').length === 1) {
    inits.push('vue-featured-products')
    new Vue({
      el: '#vue-featured-products',
      store: store,
      render(e) {
        return e(FeaturedProducts)
      }
    })
  }
  if (document.querySelectorAll('#vue-featured-brands').length === 1) {
    inits.push('vue-featured-brands')
    new Vue({
      el: '#vue-featured-brands',
      store: store,
      render(e) {
        return e(FeaturedBrands)
      }
    })
  }

  if (document.querySelectorAll('#vue-featured-categories').length === 1) {
    inits.push('vue-featured-categories')
    new Vue({
      el: '#vue-featured-categories',
      store: store,
      render(e) {
        return e(FeaturedCategories)
      }
    })
  }

  /*if (document.querySelectorAll('#vue-login-button').length === 1) {
    inits.push('vue-login')
    new Vue({
      el: '#vue-login-button',
      store: store,
      render(e) {
        return e(LoginButton)
      }
    })
  }*/

  /*if (document.querySelectorAll('#vue-register-button').length === 1) {
    inits.push('vue-register')
    new Vue({
      el: '#vue-register-button',
      store: store,
      render(e) {
        return e(RegisterButton)
      }
    })
  }*/

  if (document.querySelectorAll('#vue-modal').length === 1) {
    inits.push('vue-modal')
    new Vue({
      el: '#vue-modal',
      store: store,
      render: e => e(PortalVueModal)
    })
  }

  if (document.querySelectorAll('#vue-reseller-modal').length === 1) {
    inits.push('vue-reseller-modal')
    new Vue({
      el: '#vue-reseller-modal',
      store: store,
      render: e => e(resellerModal)
    })
  }

  if (document.querySelectorAll('#vue-root-container').length === 1) {
    inits.push('vue-root-container')
    new Vue({
      el: '#vue-root-container',
      store: store,
      render: e => e(PortalRootContainer)
    })
  }

  if (document.querySelectorAll('#vue-logout').length === 1) {
    inits.push('vue-logout')
    new Vue({
      el: '#vue-logout',
      store: store, render: e => e(Logout)
    })
  }

  for (let el of document.querySelectorAll('.vue-info-box')) {
    inits.push('vue-info-box')
    new Vue({
      el,
      store: store,
      render(e) {
        return e(InfoBox)
      }
    })
  }

  if (document.querySelectorAll('#vue-checkout').length === 1) {
    inits.push('vue-checkout')
    new Vue({
      el: '#vue-checkout',
      store: store,
      render(e) {
        return e(Checkout)
      }
    })
  }

  if (document.querySelectorAll('#vue-my-account').length === 1) {
    inits.push('vue-my-account')
    new Vue({
      el: '#vue-my-account',
      store: store,
      render(e) {
        return e(MyAccount)
      }
    })
  }

  if (document.querySelectorAll('#vue-order-status').length === 1) {
    inits.push('vue-order-status')
    new Vue({
      el: '#vue-order-status',
      store: store,
      render(e) {
        return e(OrderStatus)
      }
    })
  }

  if (document.querySelectorAll('#vue-video-category-list').length === 1) {
    inits.push('vue-video-category-list')
    new Vue({
      el: '#vue-video-category-list',
      store: store,
      render(e) {
        return e(VideoCategoryList)
      }
    })
  }

  if (document.querySelectorAll('#vue-error-404').length === 1) {
    inits.push('vue-error-404')
    new Vue({
      el: '#vue-error-404',
      store: store,
      render(e) {
        return e(Error404)
      }
    })
  }
  if (document.querySelectorAll('#vue-breadcrumbs').length === 1) {
    inits.push('vue-breadcrumbs')
    new Vue({
      el: '#vue-breadcrumbs',
      store: store,
      render(e) {
        return e(Breadcrumbs)
      }
    })
  }

  mainOverrides.extraComponents({Vue, store, inits},1000)

  debugLog("mainOverrides", mainOverrides)
  if( mainOverrides.revolutionSliderTest() ){
    RevolutionSlider()
  }

  debugLog('components: ', inits)
  Raven.setExtraContext({
    inits: inits,
  })
  setTimeout(function () {
    env.THEME_SCRIPTS.forEach(function (e) {
      get_script(...e)
    })
  }, 1000)
}

tokenInspected().then(init_components)



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/main.js